import React from 'react';

/**
 * Visa Card Badge (Source: visa-3-svgrepo-com.svg)
 */
export function VisaBadge({ width = 42, height = 26, className = '' }) {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 750 471" 
      fill="none" 
      className={className}
      style={{ borderRadius: '4px', display: 'block', boxShadow: '0 1px 3px rgba(0,0,0,0.12)' }}
    >
      <g fillRule="nonzero">
        <rect fill="#0E4595" x="0" y="0" width="750" height="471" rx="40" />
        <polygon fill="#FFFFFF" points="278.1975 334.2275 311.5585 138.4655 364.9175 138.4655 331.5335 334.2275" />
        <path d="M524.3075,142.6875 C513.7355,138.7215 497.1715,134.4655 476.4845,134.4655 C423.7605,134.4655 386.6205,161.0165 386.3045,199.0695 C386.0075,227.1985 412.8185,242.8905 433.0585,252.2545 C453.8275,261.8495 460.8105,267.9695 460.7115,276.5375 C460.5795,289.6595 444.1255,295.6545 428.7885,295.6545 C407.4315,295.6545 396.0855,292.6875 378.5625,285.3785 L371.6865,282.2665 L364.1975,326.0905 C376.6605,331.5545 399.7065,336.2895 423.6355,336.5345 C479.7245,336.5345 516.1365,310.2875 516.5505,269.6525 C516.7515,247.3835 502.5355,230.4355 471.7515,216.4645 C453.1005,207.4085 441.6785,201.3655 441.7995,192.1955 C441.7995,184.0585 451.4675,175.3575 472.3565,175.3575 C489.8055,175.0865 502.4445,178.8915 512.2925,182.8575 L517.0745,185.1165 L524.3075,142.6875" fill="#FFFFFF" />
        <path d="M661.6145,138.4655 L620.3835,138.4655 C607.6105,138.4655 598.0525,141.9515 592.4425,154.6995 L513.1975,334.1025 L569.2285,334.1025 C569.2285,334.1025 578.3905,309.9805 580.4625,304.6845 C586.5855,304.6845 641.0165,304.7685 648.7985,304.7685 C650.3945,311.6215 655.2905,334.1025 655.2905,334.1025 L704.8025,334.1025 L661.6145,138.4655 Z M596.1975,264.8725 C600.6105,253.5935 617.4565,210.1495 C617.4565,210.1495 C617.1415,210.6705 621.8365,198.8155 624.5315,191.4655 L628.1385,208.3435 C628.1385,208.3435 638.3555,255.0725 640.4905,264.8715 L596.1975,264.8715 L596.1975,264.8725 Z" fill="#FFFFFF" />
        <path d="M 45.878906 138.46484 L 45.197266 142.53906 C 66.288263 147.64458 85.126465 155.03257 101.61914 164.22461 L 148.96484 333.91602 L 205.41992 333.84961 L 289.42383 138.46484 L 232.90234 138.46484 L 180.66211 271.96094 L 175.0957 244.83203 C 174.83824 244.00408 174.55942 243.17304 174.27344 242.3418 L 156.10742 154.99219 C 152.87742 142.59619 143.50892 138.89684 131.91992 138.46484 L 45.878906 138.46484 z " fill="#ffffff" />
      </g>
    </svg>
  );
}

/**
 * Mastercard Card Badge (Source: mastercard-svgrepo-com.svg)
 */
export function MastercardBadge({ width = 42, height = 26, className = '' }) {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 70 48" 
      fill="none" 
      className={className}
      style={{ borderRadius: '4px', display: 'block', boxShadow: '0 1px 3px rgba(0,0,0,0.12)' }}
    >
      <rect x="0.5" y="0.5" width="69" height="47" rx="5.5" fill="white" stroke="#D9D9D9"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M35.3945 34.7619C33.0114 36.8184 29.92 38.0599 26.5421 38.0599C19.0047 38.0599 12.8945 31.8788 12.8945 24.254C12.8945 16.6291 19.0047 10.448 26.5421 10.448C29.92 10.448 33.0114 11.6895 35.3945 13.7461C37.7777 11.6895 40.869 10.448 44.247 10.448C51.7843 10.448 57.8945 16.6291 57.8945 24.254C57.8945 31.8788 51.7843 38.0599 44.247 38.0599C40.869 38.0599 37.7777 36.8184 35.3945 34.7619Z" fill="#ED0006"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M35.3945 34.7619C38.3289 32.2296 40.1896 28.4616 40.1896 24.254C40.1896 20.0463 38.3289 16.2783 35.3945 13.7461C37.7777 11.6895 40.869 10.448 44.247 10.448C51.7843 10.448 57.8945 16.6291 57.8945 24.254C57.8945 31.8788 51.7843 38.0599 44.247 38.0599C40.869 38.0599 37.7777 36.8184 35.3945 34.7619Z" fill="#F9A000"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M35.3946 13.7461C38.329 16.2784 40.1897 20.0463 40.1897 24.254C40.1897 28.4616 38.329 32.2295 35.3946 34.7618C32.4603 32.2295 30.5996 28.4616 30.5996 24.254C30.5996 20.0463 32.4603 16.2784 35.3946 13.7461Z" fill="#FF5E00"/>
    </svg>
  );
}

/**
 * Amex Card Badge
 */
export function AmexBadge({ width = 42, height = 26, className = '' }) {
  return (
    <svg width={width} height={height} viewBox="0 0 56 36" fill="none" className={className} style={{ borderRadius: '4px', display: 'block', boxShadow: '0 1px 3px rgba(0,0,0,0.12)' }}>
      <rect width="56" height="36" rx="5" fill="#006FCF" />
      <text x="28" y="22" textAnchor="middle" fill="white" fontSize="11.5" fontWeight="bold" fontFamily="Arial, Helvetica, sans-serif" letterSpacing="0.8">AMEX</text>
    </svg>
  );
}

/**
 * Discover Card Badge
 */
export function DiscoverBadge({ width = 42, height = 26, className = '' }) {
  return (
    <svg width={width} height={height} viewBox="0 0 56 36" fill="none" className={className} style={{ borderRadius: '4px', display: 'block', boxShadow: '0 1px 3px rgba(0,0,0,0.12)' }}>
      <rect width="56" height="36" rx="5" fill="#FF6000" />
      <text x="28" y="22" textAnchor="middle" fill="white" fontSize="9.5" fontWeight="bold" fontFamily="Arial, Helvetica, sans-serif" letterSpacing="0.4">DISCOVER</text>
    </svg>
  );
}

/**
 * Default Chip Card Badge
 */
export function DefaultCardBadge({ width = 42, height = 26, className = '' }) {
  return (
    <svg width={width} height={height} viewBox="0 0 56 36" fill="none" className={className} style={{ borderRadius: '4px', display: 'block', boxShadow: '0 1px 2px rgba(0,0,0,0.06)' }}>
      <rect width="56" height="36" rx="5" fill="#F8FAFC" stroke="#CBD5E1" strokeWidth="1.2" />
      <rect x="0" y="8" width="56" height="6" fill="#334155" />
      <rect x="7" y="18" width="8" height="6" rx="1.5" fill="#E2E8F0" stroke="#94A3B8" strokeWidth="0.8" />
      <line x1="11" y1="18" x2="11" y2="24" stroke="#94A3B8" strokeWidth="0.8" />
      <line x1="7" y1="21" x2="15" y2="21" stroke="#94A3B8" strokeWidth="0.8" />
      <rect x="18" y="20" width="14" height="2.5" rx="1" fill="#CBD5E1" />
      <rect x="35" y="20" width="12" height="2.5" rx="1" fill="#CBD5E1" />
    </svg>
  );
}

export function getCardBadge(cardType, props = {}) {
  switch (cardType) {
    case 'visa': return <VisaBadge {...props} />;
    case 'mastercard': return <MastercardBadge {...props} />;
    case 'amex': return <AmexBadge {...props} />;
    case 'discover': return <DiscoverBadge {...props} />;
    default: return <DefaultCardBadge {...props} />;
  }
}
